import React, { useState } from 'react';
import { Tab, TabItem } from '@components/atoms/Tab';
import { cn } from '@utils/cn';

export interface TabsGroupItem extends TabItem {
  content: React.ReactNode;
}

export interface TabsGroupProps {
  tabs: TabsGroupItem[];
  defaultActiveTab?: string;
  className?: string;
  variant?: 'default' | 'pills' | 'underline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  showContent?: boolean;
}

export const TabsGroup: React.FC<TabsGroupProps> = ({
  tabs,
  defaultActiveTab,
  className = '',
  variant = 'underline',
  size = 'md',
  fullWidth = false,
  showContent = true,
}) => {
  const [activeTab, setActiveTab] = useState(
    defaultActiveTab || tabs[0]?.id || '',
  );

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
  };

  const activeContent = tabs.find((tab) => tab.id === activeTab)?.content;

  return (
    <div className={cn('w-full', className)}>
      {/* Tab Navigation */}
      <Tab
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        variant={variant}
        size={size}
        fullWidth={fullWidth}
      />

      {/* Tab Content */}
      {showContent && activeContent && (
        <div className="mt-4">{activeContent}</div>
      )}
    </div>
  );
};
